// src/components/ResetPasswordConfirm.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useParams, useNavigate } from "react-router-dom";
import "../css/FormStyles.css";

const ResetPasswordConfirm = () => {
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { uid, token } = useParams();

  useEffect(() => {
    axios.get("/api/csrf/", { withCredentials: true })
      .then(() => console.log("CSRF token set."))
      .catch(() => setError("Failed to set CSRF token."));
  }, []);

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const csrfToken = Cookies.get("csrftoken");

      const res = await axios.post(
        `/api/reset-password-confirm/${uid}/${token}/`,
        { new_password: newPassword },
        {
          headers: { "X-CSRFToken": csrfToken },
          withCredentials: true,
        }
      );

      setMessage(res.data.message || "Password reset successfully.");
      setNewPassword("");

      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || "Password reset failed.");
    }
  };

  return (
    <div className="container">
      <form onSubmit={handleReset} className="login-form">
        <h2>Reset Password</h2>

        <div className="form-group">
          <input
            type="password"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>

        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <button type="submit" className="signin">change password</button>
      </form>
    </div>
  );
};

export default ResetPasswordConfirm;

